import React, { useEffect, useRef, useState } from 'react';
import { Modal, Select } from 'antd';
import PropTypes from "prop-types";
import { patchRequest } from "../../axios"; // Assuming axios methods are set up properly
import "../../styles/Main.scss"; // Import your styles
// import ConfirmDriverAssignment from './ConfirmDriverAssignment';
// import {  useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "antd/dist/antd.min.css";
import { confirmAlert } from 'react-confirm-alert';
import { SuccessNotificationMsg } from '../../utils/Notifications';

const { Option } = Select;

const AssignToDriver = ({ record, driverList, setEmployeeList, setState, reload,
    setReload }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    //   const navigate = useNavigate();
    const [selectedDriverId, setSelectedDriverId] = useState(record.driver_name || null);

    const [previousDriverId, setPreviousDriverId] = useState(record.driver_name || null);
    const [loading, setLoading] = useState(false);
    // const [modalKey, setModalKey] = useState(false);
    // const [fileList, setFileList] = useState([]);
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const [reload, setReload] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setSelectedDriverId(record?.driver_name?.id);
    }, [record])


    // const updateDriverAssignment = (packageId, driverId, newAssignedToId) => {
    //     setEmployeeList((prevState) =>
    //         prevState.map((item) =>
    //             item.id === packageId
    //                 ? { ...item, assigned_to_id: newAssignedToId, assigned_to: { ...item.assigned_to, id: driverId } }
    //                 : item
    //         )
    //     );
    // };
    const updateDriverAssignment = (packageId, value, newAssignedToId, driverName) => {

        setEmployeeList((prevState) =>
            prevState.map((item) =>
                item.id === packageId
                    ? {
                        ...item,
                        assigned_to_id: newAssignedToId,
                        assigned_to: { id: value, name: driverName }  // Ensure both id and name are updated
                    }
                    : item
            )
        );
    };
    // const handleConfirm = async () => {
    //     setLoading(true);
    //     try {
    //         const payload = {
    //             id: record.assigned_to_id,
    //             packages: [record.id],
    //             driver: selectedDriverId,
    //         };

    //         const response = await postRequest("assign-package-to-driver/", payload);
    //         if (response.data.success) {
    //             updateDriverAssignment(record.id, selectedDriverId, response?.data?.data?.id);
    //         } else {
    //             console.error("Error assigning driver", response.data.message);
    //         }
    //     } catch (error) {
    //         console.error("API call failed", error);
    //     } finally {
    //         setLoading(false);
    //         closeModal();
    //     }
    // };
    const handleAssign = async (recordId, driverId) => {
        setLoading(true);
        try {
            const payload = {
                // id: record.driver_name,
                route: recordId,
                driver: driverId,
            };

            const response = await patchRequest("route/assign-route-to-other-driver/", payload);
            if (response.data.success) {
                updateDriverAssignment(recordId, driverId, response?.data?.data?.id);
                SuccessNotificationMsg("Route Assigned To Driver Successfully")
                setReload(reload=>!reload);
            } else {
                console.error("Error assigning driver", response.data.message);
            }
        } catch (error) {
            console.error("API call failed", error);
        } finally {
            setLoading(false);
            closeModal();
        }
    };

    // const handleUnassign = () => {
    //     // Just close the modal and do not call the API
    //     closeModal();
    // };
    const showModal = () => {
        setIsModalVisible(true);
    };

    const closeModal = () => {
        setIsModalVisible(false);
        setSelectedDriverId(previousDriverId); // Revert back if canceled

    };
    const handleResidentSelectChange = async (id, value) => {
        setLoading(true);
        confirmAlert({
            title: t("confirmAlert_assigned_driver_title"),
            message: t("confirmAlert_assigned_driver_message"),
            buttons: [
                {
                    label: t("confirmAlert_ok"),
                    onClick: () => handleAssign(id, value),
                },
                {
                    label: t("confirmAlert_cancel"),
                    onClick: () => {
                        setLoading(false);
                        // Restore previous selection on cancel
                        setSelectedDriverId(previousDriverId);
                    },
                },
            ],
        });
    };
    const selectedDriverIdRef = useRef(selectedDriverId);

    useEffect(() => {
        if (record?.driver_name) {
            selectedDriverIdRef.current = record.driver_name;
            setSelectedDriverId(record.driver_name);
            setPreviousDriverId(record.driver_name);
        }
    }, [record]);
    const handleDriverChange = (value) => {
        // Store the current selection before changing
        setPreviousDriverId(selectedDriverId); // Store the previous ID
        setSelectedDriverId(value); // Update to new selection
        handleResidentSelectChange(record.id, value); // Show confirmation dialog
    };
    

    return (
        <>
            <Select
                className="gridselect" // Apply your CSS class
                onChange={handleDriverChange}
                showArrow
                placeholder="Select Driver"
                // value={selectedDriverId}
                value={selectedDriverIdRef.current || undefined}
            >
                {driverList?.map((driver) => (
                    <Option key={driver.id} value={driver.id}>
                        {driver.name}
                    </Option>
                ))}
            </Select>
            <Modal
                title="Confirm Driver Assignment"
                visible={isModalVisible}
                onCancel={closeModal}

            >
                <p>Are you sure you want to assign this driver?</p>
            </Modal>

        </>
    );
};

AssignToDriver.propTypes = {
    record: PropTypes.object.isRequired,
    driverList: PropTypes.array.isRequired,
    setEmployeeList: PropTypes.func.isRequired,
    setState: PropTypes.func.isRequired,
    reload: PropTypes.func.isRequired,
    setReload: PropTypes.func.isRequired,
};

export default AssignToDriver;
